import script from "./PolicyInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyInvoice.vue?vue&type=script&setup=true&lang=js"

import "./PolicyInvoice.vue?vue&type=style&index=0&id=48d9b32d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d9b32d"]])

export default __exports__